import { Reducer } from 'redux'
import { initialBlankState } from './initialState'
import { AccountCreateState, ActionTypes } from './types'
const reducer: Reducer<AccountCreateState> = (
  state = initialBlankState.accountCreateForm,
  action,
) => {
  switch (action.type) {
    case ActionTypes.ON_CHANGE: {
      return action.payload
    }
    case ActionTypes.LAWYER_QUERY_REQUEST: {
      return {
        ...state,
        generalInfo: {
          ...state.generalInfo,
          checkingIdentityNumber: true,
          lawyerInfo: undefined,
        },
      }
    }
    case ActionTypes.LAWYER_QUERY_FULFILLED: {
      return {
        ...state,
        generalInfo: {
          ...state.generalInfo,
          checkingIdentityNumber: false,
          lawyerInfo: action.payload,
        },
      }
    }
    case ActionTypes.LAWYER_RESPONSE_CLEAR: {
      return {
        ...state,
        generalInfo: {
          ...state.generalInfo,
          checkingIdentityNumber: false,
          lawyerInfo: null,
        },
      }
    }
    case ActionTypes.PAYMENT_3DS_FULLFILLED: {
      return {
        ...state,
        payment3dsResponse: {
          ...state.payment3dsResponse,
          threeDSHtmlContent: action.payload.threeDSHtmlContent,
        },
      }
    }
    case ActionTypes.PREVIEW_DEALER_CONTRACT_REQUEST: {
      return {
        ...state,
        dealerContract: {
          ...state.dealerContract,
          isQuerying: true,
          isSigning: false,
          signedContent: undefined,
          errorMessage: undefined,
        },
        dealerContractPageActive: true,
      }
    }
    case ActionTypes.PREVIEW_DEALER_CONTRACT_FULFILLED: {
      return {
        ...state,
        dealerContract: {
          ...state.dealerContract,
          isQuerying: false,
          isSigning: false,
          signedContent: action.payload.base64Content,
          errorMessage: action.payload.errorMessage,
        },
      }
    }
    case ActionTypes.PREVIEW_DEALER_CONTRACT_REJECTED: {
      return {
        ...state,
        dealerContract: {
          ...state.dealerContract,
          isQuerying: false,
          isSigning: false,
          signedContent: undefined,
          errorMessage:
            (action.payload.response &&
              action.payload.response.data &&
              action.payload.response.data.message) ||
            'Hata oluştu!',
        },
      }
    }
    case ActionTypes.SIGN_DEALER_CONTRACT_REQUEST: {
      return {
        ...state,
        dealerContract: {
          ...state.dealerContract,
          isQuerying: false,
          isSigning: true,
          signedContent: undefined,
          errorMessage: undefined,
        },
      }
    }
    case ActionTypes.SIGN_DEALER_CONTRACT_FULFILLED: {
      return {
        ...state,
        dealerContract: {
          ...state.dealerContract,
          isQuerying: false,
          isSigning: false,
          signedContent: action.payload.result,
          errorMessage: action.payload.errorMessage,
        },
        dealerContractPageActive: false,
        currentStep: state.currentStep + 1,
      }
    }
    case ActionTypes.SIGN_DEALER_CONTRACT_REJECTED: {
      return {
        ...state,
        dealerContract: {
          ...state.dealerContract,
          isQuerying: false,
          isSigning: false,
        },
      }
    }
    case ActionTypes.PREVIEW_CAMPAIN_CONTRACT_REQUEST: {
      return {
        ...state,
        campainContract: {
          ...state.campainContract,
          isQuerying: true,
          isSigning: false,
          signedContent: undefined,
          errorMessage: undefined,
        },
      }
    }
    case ActionTypes.PREVIEW_CAMPAIN_CONTRACT_REJECTED: {
      return {
        ...state,
        campainContract: {
          ...state.campainContract,
          isQuerying: false,
          isSigning: false,
          signedContent: undefined,
          errorMessage:
            (action.payload.response &&
              action.payload.response.data &&
              action.payload.response.data.message) ||
            'Hata oluştu!',
        },
      }
    }
    case ActionTypes.PREVIEW_CAMPAIN_CONTRACT_FULFILLED: {
      return {
        ...state,
        campainContract: {
          ...state.campainContract,
          isQuerying: false,
          isSigning: false,
          signedContent: action.payload.base64Content,
          errorMessage: action.payload.errorMessage,
        },
      }
    }
    case ActionTypes.SIGN_CAMPAIN_CONTRACT_REQUEST: {
      return {
        ...state,
        campainContract: {
          ...state.campainContract,
          isQuerying: false,
          isSigning: true,
          signedContent: undefined,
          errorMessage: undefined,
        },
        campainContractPageActive: false,
      }
    }
    case ActionTypes.SIGN_CAMPAIN_CONTRACT_FULFILLED: {
      return {
        ...state,
        campainContract: {
          ...state.campainContract,
          isQuerying: false,
          isSigning: false,
          signedContent: action.payload.result,
          errorMessage: action.payload.errorMessage,
        },
        currentStep: state.currentStep + 1,
      }
    }
    case ActionTypes.SIGN_CAMPAIN_CONTRACT_REJECTED: {
      return {
        ...state,
        campainContract: {
          ...state.campainContract,
          isQuerying: false,
          isSigning: false,
        },
      }
    }
    case ActionTypes.STEP_INFO_CHECK_REQUEST: {
      return {
        ...state,
        stepInfoChecking: true,
        stepInfoChecked: false,
        selectedPlanCode: undefined,
        campainContract: {
          exist: false,
          isSigning: false,
        },
        dealerContract: {
          exist: false,
          isSigning: false,
        },
      }
    }
    case ActionTypes.STEP_INFO_CHECK_FULFILLED: {
      return {
        ...state,
        stepInfoChecking: false,
        stepInfoChecked: true,
        campainInfo:
          action.payload.campainInfo !== null
            ? { ...state.campainInfo, ...action.payload.campainInfo }
            : undefined,
        // dealerContract:
        //   action.payload.isQualified === true
        //     ? { ...state.dealerContract, ...action.payload.dealerContract }
        //     : {
        //         isQuerying: false,
        //         isSigning: false,
        //         exist: false,
        //         isVerified: false,
        //       },
        dealerContract: { ...state.dealerContract, ...action.payload.dealerContract },
        // campainContract:
        //   action.payload.isQualified === true
        //     ? { ...state.campainContract, ...action.payload.campainContract }
        //     : {
        //         isQuerying: false,
        //         isSigning: false,
        //         exist: false,
        //         isVerified: false,
        //       },
        campainContract: { ...state.campainContract, ...action.payload.campainContract },
        // currentStep: state.currentStep + 1,
      }
    }
    default: {
      return state
    }
  }
}

export default reducer
